import { Button } from "./ui/Button";
import { Icon } from "./ui/Icon";

export function NoPermissionPage({ onBack }: { readonly onBack: () => void }) {
  return <section className="empty-page console-state-page"><span className="empty-state-icon"><Icon name="key" /></span><strong>没有访问权限</strong><p>当前开发者角色无权访问该应用功能，请联系应用所有者调整权限。</p><Button onClick={onBack}>返回应用概览</Button></section>;
}

export function NotFoundPage({ onBack }: { readonly onBack: () => void }) {
  return <section className="empty-page console-state-page"><span className="empty-state-icon"><Icon name="search" /></span><strong>页面不存在</strong><p>链接可能已失效，或者对应应用不属于当前开发者账号。</p><Button variant="primary" onClick={onBack}>返回应用中心</Button></section>;
}
